'use client';

import { c as _c } from "react/compiler-runtime";
import Typography from '@/components/core/Typography/Typography';
import { ForwardedRef, forwardRef, useCallback } from 'react';
import { useForwardRef } from '@/utils/useForwardRef';
import { buttonVariants } from '@/components/core/Button/styles';
const Button = forwardRef(function DirectButton(t0, forwardedRef) {
  const $ = _c(38);
  let endAdornment;
  let icon;
  let innerText;
  let leftIcon;
  let onClick;
  let props;
  let rightIcon;
  let startAdornment;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[0] !== t0) {
    ({
      variant: t1,
      innerText,
      startAdornment,
      endAdornment,
      leftIcon,
      rightIcon,
      size: t2,
      error: t3,
      disabled: t4,
      onClick,
      withBlur: t5,
      icon,
      highlighted: t6,
      textModifier: t7,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = endAdornment;
    $[2] = icon;
    $[3] = innerText;
    $[4] = leftIcon;
    $[5] = onClick;
    $[6] = props;
    $[7] = rightIcon;
    $[8] = startAdornment;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    endAdornment = $[1];
    icon = $[2];
    innerText = $[3];
    leftIcon = $[4];
    onClick = $[5];
    props = $[6];
    rightIcon = $[7];
    startAdornment = $[8];
    t1 = $[9];
    t2 = $[10];
    t3 = $[11];
    t4 = $[12];
    t5 = $[13];
    t6 = $[14];
    t7 = $[15];
  }
  const variant = t1 === undefined ? "filled" : t1;
  const size = t2 === undefined ? "sm" : t2;
  const error = t3 === undefined ? false : t3;
  const disabled = t4 === undefined ? false : t4;
  const withBlur = t5 === undefined ? true : t5;
  const highlighted = t6 === undefined ? false : t6;
  const textModifier = t7 === undefined ? "S" : t7;
  const ref = useForwardRef(forwardedRef);
  let t8;
  if ($[16] !== onClick || $[17] !== ref || $[18] !== withBlur) {
    t8 = e => {
      if (ref && withBlur) {
        ref.current.blur();
      }
      if (onClick) {
        onClick(e);
      }
    };
    $[16] = onClick;
    $[17] = ref;
    $[18] = withBlur;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  const handleClick = t8;
  const Component = buttonVariants[variant];
  const t9 = onClick && withBlur ? handleClick : undefined;
  const t10 = error ? true : undefined;
  const t11 = disabled ? true : undefined;
  const t12 = props.type || "button";
  const t13 = startAdornment || leftIcon;
  let t14;
  if ($[20] !== innerText || $[21] !== size || $[22] !== textModifier) {
    t14 = innerText && (typeof innerText === "string" ? <Typography variant="uiType" modifier={textModifier} size={size === "xs" ? "xs" : "sm"}>{innerText}</Typography> : innerText);
    $[20] = innerText;
    $[21] = size;
    $[22] = textModifier;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  const t15 = endAdornment || rightIcon;
  let t16;
  if ($[24] !== Component || $[25] !== highlighted || $[26] !== icon || $[27] !== props || $[28] !== ref || $[29] !== size || $[30] !== t10 || $[31] !== t11 || $[32] !== t12 || $[33] !== t13 || $[34] !== t14 || $[35] !== t15 || $[36] !== t9) {
    t16 = <Component ref={ref} onClick={t9} size={size} data-error={t10} disabled={t11} type={t12} $icon={icon} $highlighted={highlighted} {...props}>{t13}{t14}{t15}</Component>;
    $[24] = Component;
    $[25] = highlighted;
    $[26] = icon;
    $[27] = props;
    $[28] = ref;
    $[29] = size;
    $[30] = t10;
    $[31] = t11;
    $[32] = t12;
    $[33] = t13;
    $[34] = t14;
    $[35] = t15;
    $[36] = t9;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  return t16;
});
export default Button;